import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntSelectComponent} from "./int-select.component";
import {IntInputModule} from "../int-input/int-input.module";
import {IntDropdownChevronModule} from "../chanks";


@NgModule({
  imports: [
    CommonModule,
    IntInputModule,
    IntDropdownChevronModule
  ],
  declarations: [
    IntSelectComponent
  ],
  exports: [
    IntSelectComponent
  ]
})
export class IntSelectModule {}
